module.exports = __webpack_public_path__ + "static/media/subtract 1.75d6b107.webp";